export type MainNavArea = 'gnb' | 'content' | 'footer' | 'zoom';

/**
 * Chu trình zoom khi ArrowDown / Tab forward giữa vùng chính.
 * Hai mảng tách biệt — chỉnh VERTICAL không được đổi HORIZONTAL.
 */
/** Màn ngang + zoom (giữ nguyên khi sửa dọc) */
export const ZOOM_MAIN_NAV_ORDER_HORIZONTAL: MainNavArea[] = ['gnb', 'content', 'footer', 'zoom'];

/** Màn dọc + zoom */
export const ZOOM_MAIN_NAV_ORDER_VERTICAL: MainNavArea[] = ['content', 'gnb', 'footer', 'zoom'];

export const getZoomMainNavOrder = (isHorizontal: boolean): MainNavArea[] =>
    isHorizontal ? ZOOM_MAIN_NAV_ORDER_HORIZONTAL : ZOOM_MAIN_NAV_ORDER_VERTICAL;

export const getAdjacentMainNavAreaInCycle = (
    from: MainNavArea,
    direction: 'next' | 'prev',
    isHorizontal: boolean
): MainNavArea | null => {
    const order = getZoomMainNavOrder(isHorizontal);
    const currentIndex = order.indexOf(from);
    if (currentIndex === -1) {
        return null;
    }
    const step = direction === 'next' ? 1 : -1;
    return order[(currentIndex + step + order.length) % order.length];
};
